export interface NativeAttributes {
  title: string;
  description: string;
  sponsored_by: string;
  call_to_action: string;
}

export interface VioohInventory {
  seller_id: string;
}

export interface PlayerEvents {
  type: string;
  url: string;
}

export class CreativePixel {
  format: "image" | "js";
  url: string;
}

export interface Creatives {
  name: string;
  ad_type: string;
  state: "active" | "inactive";
  upload_type: "file" | "tag";
  third_party_pixels: Array<any>;
  javascript_tags: Array<any>;
  folder: number;
  width: number;
  height: number;
  description: string;
  third_party_tag: string;
  landing_page_url: string;
  click_through_url: string;
  native_attributes: NativeAttributes;
  companion_creative_ids: string;
  is_retargeting_enabled: boolean;
  viooh_inventory: VioohInventory;
  events: Array<PlayerEvents>;
}

export interface CreativeDimension {
  width: number;      
  height: number;  
  bidFactor: number;
  count?: number;
}

export const adTypes = [
  { label: "Banner", value: "banner", toolTip: "" },
  { label: "HTML5", value: "html5", toolTip: "" },
  { label: "Video/CTV", value: "video", toolTip: "" },
  { label: "Audio", value: "audio", toolTip: "" },
  { label: "Native Banner", value: "native_banner", toolTip: "" },
  { label: "Native Video", value: "native_video", toolTip: "" },
  // {
  //   value: "dooh_banner",
  //   label: "DOOH Banner",
  //   toolTip: "Banner advertising displayed on digital screens in public spaces",
  // },
  // {
  //   value: "dooh_video",
  //   label: "DOOH Video",
  //   toolTip: "Video advertising displayed on digital screens in public spaces",
  // },
];

export const tdspNativeTypes: Set<string> = new Set([
  "native_banner",
  "native_video",
]);

export const nonImgCrtv: Set<string> = new Set([
  "audio",
  "video",
  "native_video",
]);

export const doohCrtvTypes: Set<string> = new Set([
  "dooh_banner",
  "dooh_video",
]);

export const hasNoAssetDimension: Set<string> = new Set([
  "video",
  "audio",
  "native_banner",
  "native_video",
]);

export enum TdspCrtvConstant {
  MAX_ICON_DIMENSION = 200,
  MAX_LOGO_DIMENSION = 512,
  MAX_TITLE_CHAR = 90,
  MAX_DESC_CHAR = 140,
  MAX_SPONSOR_CHAR = 100,
}

export const crtvEvents = [
  "start",
  "mid_point",
  "first_quartile",
  "third_quartile",
  "complete",
  "impression",
  "click",
];
